import React from 'react';
import { ArrowRightIcon, CheckIcon, LockIcon, ZapIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { CHECKOUT_URL, IMAGES } from '../lib/config';
const summary = [{
  label: 'Manual maestro Kit Consultorio Sencillo',
  value: '$12.900'
}, {
  label: '5 herramientas en Excel (costos, presupuesto, stock, proveedores, turnos)',
  value: '$18.500'
}, {
  label: 'BONO · Plantillas de Presupuesto (PDF)',
  value: 'GRATIS'
}, {
  label: 'BONO · 4 Modelos de Contrato (Word)',
  value: 'GRATIS'
}, {
  label: 'BONO · Presentación de Plan de Tratamiento',
  value: 'GRATIS'
}, {
  label: 'BONO · 5 Ilustraciones de Tratamientos',
  value: 'GRATIS'
}, {
  label: 'BONO · Odontología para Niños (manual + ilustraciones)',
  value: 'GRATIS'
}];
export function FinalOffer() {
  return <section id="compra" className="scroll-mt-4 px-4 py-10" data-id="element-72" data-mp="294jf1t1qoi6j">
      <div className="rounded-3xl border border-teal-400/30 bg-[#0b2431]/90 p-4 shadow-2xl shadow-black/50" data-id="element-73" data-mp="292zzy5rtkd6c">
        <p className="mx-auto w-fit rounded-full bg-teal-500 px-3 py-1 text-[11px] font-extrabold uppercase tracking-wide text-[#062331]" data-id="element-74" data-mp="24456m9w8767z">
          Oferta de lanzamiento
        </p>

        <h2 className="mt-3 text-center text-2xl font-black leading-snug text-white" data-id="element-75" data-mp="6qmghoa22cfk">
          Ordená tu consultorio hoy mismo
        </h2>

        <a href={CHECKOUT_URL} className="mt-4 block overflow-hidden rounded-2xl border border-white/10 bg-white/5 p-1" data-id="element-76" data-mp="gn924fa7h7in">
          <img src={IMAGES.product} alt="Todo lo que incluye el Kit Consultorio Sencillo" className="w-full rounded-xl" data-id="element-77" data-mp="ko1cxcyq7kh1" />
        </a>

        <div className="mt-5" data-id="element-78" data-mp="ufffjtlz50ee">
          <Countdown data-id="element-79" data-mp="uggsk3mjvwyr" />
        </div>

        <div className="mt-5 rounded-2xl border border-white/10 bg-white/5 p-4" data-id="element-80" data-mp="zdqtogjaxx2f">
          <p className="text-xs font-extrabold uppercase tracking-wide text-teal-200" data-id="element-81" data-mp="14ck583f13dzy">
            Resumen de tu pedido
          </p>
          <ul className="mt-3 space-y-2.5" data-id="element-82" data-mp="18ex9soi1h5v5">
            {summary.map(item => <li key={item.label} className="flex items-start justify-between gap-3 border-b border-white/5 pb-2.5 last:border-0 last:pb-0" data-id="element-83" data-mp="35dqek0ntvnjv">
                <span className="flex items-start gap-2 text-[13px] leading-snug text-teal-50/90" data-id="element-84" data-mp="3e7d7lj0nicpd">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-teal-400" aria-hidden="true" data-id="element-85" data-mp="39flf32xxpwwl" />
                  {item.label}
                </span>
                <span className={`shrink-0 text-[12px] font-bold ${item.value === 'GRATIS' ? 'text-amber-300' : 'text-teal-100/50 line-through'}`} data-id="element-86" data-mp="3j6pv85zcjnt0">
                  {item.value}
                </span>
              </li>)}
          </ul>

          <div className="mt-4 flex items-center justify-between border-t border-white/10 pt-3" data-id="element-87" data-mp="1yq31wpo6m56g">
            <span className="text-sm font-semibold text-teal-100/80" data-id="element-88" data-mp="1om4nd7c81shf">
              Valor total
            </span>
            <span className="text-sm font-bold text-teal-100/50 line-through" data-id="element-89" data-mp="1so9h062o6p42">
              $48.900
            </span>
          </div>
        </div>

        <div className="mt-5 text-center" data-id="element-90" data-mp="1ew30ujzioi4m">
          <p className="text-sm font-semibold text-teal-100/60" data-id="element-91" data-mp="1jv63xyvxse9y">
            Precio anterior{' '}
            <span className="line-through" data-id="element-92" data-mp="14yf81zlh1kp3">$48.900</span>
          </p>
          <p className="mt-1 text-5xl font-black tracking-tight text-white" data-id="element-93" data-mp="1509op1ppmqnd">
            $21.999
          </p>
          <p className="mt-1 text-xs font-semibold text-amber-300" data-id="element-94" data-mp="vxgyz2w6emzn">
            Pago único · Bonos incluidos gratis solo por hoy
          </p>
        </div>

        <a href={CHECKOUT_URL} className="group mt-5 flex w-full items-center justify-center gap-2 rounded-2xl bg-teal-500 px-5 py-4 text-center text-base font-extrabold uppercase tracking-wide text-[#062331] shadow-lg shadow-teal-500/30 transition active:scale-[0.98] hover:bg-teal-400" data-id="element-95" data-mp="10xd6vd7zuykh">
          Quiero ordenar mi consultorio
          <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-96" data-mp="q9ifrt9ebop4" />
        </a>

        <div className="mt-3 flex items-center justify-center gap-4 text-[11px] text-teal-100/60" data-id="element-97" data-mp="l9mi0brakti0">
          <span className="inline-flex items-center gap-1" data-id="element-98" data-mp="h93swpgsa1ji">
            <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-99" data-mp="hawye1fnufpx" /> Pago seguro
          </span>
          <span className="inline-flex items-center gap-1" data-id="element-100" data-mp="cbkdhm8cnipz">
            <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-101" data-mp="7hpt0gkx6zpu" /> Entrega
            inmediata
          </span>
        </div>
      </div>
    </section>;
}